import baseURL from '../api/url'

export const adpConfigURL = `${baseURL.CONFIG_URL}/catalogadmin/configurations`
